var exports = {
  "k": "x234b8571--11421b--container",
};

module.exports = exports;
